import { ClosableModal } from '@Components/shared/dialogs/ClosableModal';

// Styles
import { CreateLocalizationKeyForm } from './CreateLocalizationKeyForm';
import { useLocalization } from '@Modal/hooks/localization/useLocalization';

export const CreateLocalizationKeyModalDialog = () => {
  const { showCreateLocalizationKeyDialog, handleCreateLocalizationKeyDialog } = useLocalization();
  return (
    <>
      {showCreateLocalizationKeyDialog && (
        <ClosableModal
          name="CreateLocalizationKey"
          title="Create Language Key"
          open={showCreateLocalizationKeyDialog}
          onClose={() => handleCreateLocalizationKeyDialog(false)}
          sx={{ width: '592px' }}
        >
          <CreateLocalizationKeyForm />
        </ClosableModal>
      )}
    </>
  );
};
